import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CallAudioService {
  private baseUrl = `${environment.apiUrlRest}/rest/v1/outbound_calls`;

  constructor(private http: HttpClient) {}

  downloadAudio(callId: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${callId}/download`, {
      responseType: 'blob',
    });
  }
}
